// @ts-nocheck
import { put, select, takeLatest } from 'redux-saga/effects';
import { getAPIDataV3 } from 'utils/api';
import { REQUESTS } from 'utils/services/thetaretail/requests';
import * as sagaActions from './sagaActions';
import { setOrderExplanation, setOrderExplanationError, setOrderExplanationLoading } from './reducer';
import { getOrderExplanation } from './selector';
import { getState } from 'reducers';

function* fetchOrderExplanation({ payload }) {
	const { orderDetailId } = payload;

	// Check if data already exists (caching)
	const state = getState();
	const cachedData = getOrderExplanation(state, orderDetailId);
	if (cachedData) {
		// Data already cached, no need to fetch again
		return;
	}

	// Set loading state
	yield put(
		setOrderExplanationLoading({
			orderDetailId,
			loading: true,
		})
	);

	try {
		// Verify REQUESTS is available
		const requestConfig = REQUESTS?.GET?.GET_ORDER_EXPLANATION;
		if (!requestConfig) {
			throw new Error('REQUESTS.GET.GET_ORDER_EXPLANATION is not defined. Please restart the application.');
		}
		const { data } = yield getAPIDataV3({
			service: requestConfig.service,
			url: requestConfig.url,
			pathParams: { orderDetailId },
		});

		// Store the explanation data, preserving the full API payload under data.data
		const explanationPayload = {
			tooltipText: data?.tooltipText || '',
			explanation: data?.explanation,
			generatedAt: data?.generatedAt,
			modelVersion: data?.modelVersion,
			// New API shape is { data: { ...domainFields } }
			...(data?.data ?? {}),
		};

		yield put(
			setOrderExplanation({
				orderDetailId,
				data: explanationPayload,
			})
		);
	} catch (error) {
		yield put(
			setOrderExplanationError({
				orderDetailId,
				error: error?.message || 'Failed to fetch explanation',
			})
		);
	} finally {
		yield put(
			setOrderExplanationLoading({
				orderDetailId,
				loading: false,
			})
		);
	}
}

export default function* rootSaga() {
	return [yield takeLatest(sagaActions.fetchOrderExplanation, fetchOrderExplanation)];
}

